import React, { Component } from "react";
import {Link} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import ReactTableWrapperProjects from "../Table/ReactTableWrapperProjects";

class ProjectContainer extends Component {
  constructor(props) {
    super(props);

    this.handleMyProjectClick = this.handleMyProjectClick.bind(this);
    this.handleAllProjectClick = this.handleAllProjectClick.bind(this);

    this.state = {myProjects: true};
  }

    handleMyProjectClick = () => {
        if (!this.state.myProjects) {
            this.setState({ myProjects: true });
        }
    };

    handleAllProjectClick = () => {
        if (this.state.myProjects) {
            this.setState({ myProjects: false });
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.myProjects !== this.props.myProjects ||
            nextProps.allProjects !== this.props.allProjects ||
            nextState.myProjects !== this.state.myProjects
        );
    }

  render() {
    const { handleShow, handleShareShow, t } = this.props;

    return (
      <div className="card">
        <div className="content">
          <div className="panel-body">
            <div className="Bar-btn-container knoa-region" tabIndex={"-1"}>
              <Link
                to={{
                  pathname: "/admin/newProject",
                  state: {
                    newProject: true
                  }
                }}
                className="btn btn-default NavBar-btn btn-md">
                {t('common:newProject')}
              </Link>
            </div>
            <br/>
            <div className={"knoa-region"} tabIndex={"-1"}>
                {this.state.myProjects && <a className="linkOff" onClick={this.handleMyProjectClick} >{t('project:myProjects')}</a>}
                {!this.state.myProjects && <a className="linkOn" role="button" tabIndex="0" onClick={this.handleMyProjectClick} >{t('project:myProjects')}</a>}
                &nbsp;|&nbsp;
                {this.state.myProjects && <a className="linkOn" role="button" tabIndex="0" onClick={this.handleAllProjectClick} >{t('project:allProjects')}</a>}
                {!this.state.myProjects && <a className="linkOff"  onClick={this.handleAllProjectClick} >{t('project:allProjects')}</a>}
            </div>
            <br/><br/>
            <ReactTableWrapperProjects
              projects={this.state.myProjects ? this.props.myProjects : this.props.allProjects}
              handleShow={handleShow}
              handleShareShow={handleShareShow}
              t={t}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ProjectContainer);